import PropTypes from 'prop-types';
import { useState } from 'react';

import { getLatestFormTemplateVersion } from '../../utils/utils';
import ActiveToggleConfirmation from '../presentational/ActiveToggleConfirmation/ActiveToggleConfirmation';
import FormTemplateCard from '../presentational/FormTemplateCard/FormTemplateCard';

export function FormTemplateList(props) {
  const { formTemplateAllIds, formTemplateRequestLoading, formTemplates, onConfirmActiveToggle, onDuplicate } = props;

  const [formTemplateInFocus, setFormTemplateInFocus] = useState(null);
  const [showActivationModal, setShowActivationModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleCloseActivationModal = () => {
    setFormTemplateInFocus(null);
    setShowActivationModal(false);
  };

  const handleConfirmTemplateActiveToggle = async (active, reasonForChange) => {
    setIsLoading(true);
    await onConfirmActiveToggle(formTemplateInFocus, active, reasonForChange);
    setIsLoading(false);
    handleCloseActivationModal();
  };

  const handleShowActivationModal = (id) => {
    setFormTemplateInFocus(id);
    setShowActivationModal(true);
  };

  if (formTemplateRequestLoading) {
    return (
      <>
        <FormTemplateCard title="..." titleClass="loader-text" active={false} />
        <FormTemplateCard title="..." titleClass="loader-text" active={false} />
      </>
    );
  }
  return (
    <>
      {formTemplateAllIds.map((element) => {
        if (formTemplates[element] === undefined) return null;
        return (
          <FormTemplateCard
            key={formTemplates[element].id}
            templateId={formTemplates[element].id}
            title={getLatestFormTemplateVersion(formTemplates[element]).title}
            active={formTemplates[element].active}
            numberOfLibraries={formTemplates[element].trial_containers.length}
            numberOfVersions={formTemplates[element].versions.length}
            handleShowActivationModal={handleShowActivationModal}
            onDuplicate={onDuplicate}
            titleClass="form-template-card__title"
            workflowName={formTemplates[element].workflow_definition_name}
          />
        );
      })}
      {showActivationModal && formTemplateInFocus != null && (
        <ActiveToggleConfirmation
          showModal={showActivationModal}
          active={formTemplates[formTemplateInFocus]?.active}
          closeModal={handleCloseActivationModal}
          showLoadingIcon={isLoading}
          handleConfirmation={handleConfirmTemplateActiveToggle}
        />
      )}
    </>
  );
}

FormTemplateList.propTypes = {
  formTemplates: PropTypes.objectOf(PropTypes.shape()).isRequired,
  formTemplateAllIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  formTemplateRequestLoading: PropTypes.bool.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  onConfirmActiveToggle: PropTypes.func.isRequired,
};

export default FormTemplateList;
